<template>
  <div class="ep-loading" v-if="loading">
    <span class="ep-loading--dot"></span>
    <span class="ep-loading--dot"></span>
    <span class="ep-loading--dot"></span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {

  name: 'loading',

  computed: mapGetters({
    loading: 'application/loading',
  }),
};
</script>



// WEBPACK FOOTER //
// src/components/loading.vue